"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        height: '100%',
        width: '100%',
    },
    input: {
        height: '70%',
        margin: '15%',
        padding: 0,
        width: '70%',
    },
});
var DocumentPageCheckboxInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var id = input.id, status = input.status, value = input.value;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    return (react_1.default.createElement("div", { className: statusClass + " " + classes.root },
        react_1.default.createElement("input", { type: "checkbox", className: classes.input, "data-tid": "DocumentPageCheckboxInput-input-" + id, disabled: status === types_1.PageInputStatus.Disabled, onChange: function (e) { return onChange(e.target.checked); }, onFocus: function () { return onFocus(); }, checked: value !== null && value !== void 0 ? value : false })));
};
exports.default = DocumentPageCheckboxInput;
//# sourceMappingURL=DocumentPageCheckboxInput.js.map